import { ArrowLeftOutlined, SwapLeftOutlined } from "@ant-design/icons";
import { useNavigate, useNavigation } from "react-router-dom"

const Goback = () => {
    const navigate = useNavigate();

    return (
        <div className="mb-4">
            <div style={{cursor: "pointer", width: "fit-content"}} onClick={() => navigate(-1)} className="d-flex align-contents-center">
                {/* <SwapLeftOutlined /> */}
                <ArrowLeftOutlined />
                <p style={{marginLeft: 10, fontSize: "16px"}}>Kthehu prapa</p>
            </div>
        </div>
    )
}

export default Goback